import React from "react";
import style from "./index.module.scss";
import { Popover } from "antd";

interface StatisticsProps {
    signId: number;
    className?: string;
    refObj: React.RefObject<HTMLDivElement>;
    courseStuCount: number;
    signInStuCount: number;
    notSingInStuCount: number;
    onDelete: () => void;
    onExport: () => void;
    gotoDetail: (signInId: number, params?: StringMap) => void;
}

const Statistics: React.FC<StatisticsProps> = ({
    signId,
    className,
    refObj,
    courseStuCount,
    signInStuCount,
    notSingInStuCount,
    onDelete,
    onExport,
    gotoDetail
}) => {
    const popover = (
        <div className={style.popover}>
            <button onClick={onExport}>导出</button>
            <button onClick={onDelete}>删除</button>
        </div>
    );

    return (
        <div className={`${style.root} ${className}`}>
            <div className={style.wrapper}>
                <div
                    className={style.item}
                    onClick={() => gotoDetail(signId, { status: "all" })}>
                    {courseStuCount}
                    <br />
                    课程人数
                </div>
                <div
                    className={style.item}
                    onClick={() => gotoDetail(signId, { status: "sign" })}>
                    {signInStuCount}
                    <br />
                    已签到
                </div>
                <div
                    className={style.item}
                    onClick={() => gotoDetail(signId, { status: "unSign" })}>
                    {notSingInStuCount}
                    <br />
                    未签到
                </div>
            </div>

            <Popover
                content={popover}
                placement="bottom"
                overlayClassName={style.popoverWrapper}
                getPopupContainer={() => refObj.current!}>
                <button className={style.more} />
            </Popover>
        </div>
    );
};

export default Statistics;
